import { render } from "./MshelClub.vue?vue&type=template&id=560cc16c&scoped=true"
import script from "./MshelClub.vue?vue&type=script&lang=js"
export * from "./MshelClub.vue?vue&type=script&lang=js"

import "./MshelClub.vue?vue&type=style&index=0&id=560cc16c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560cc16c"]])

export default __exports__